import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { AgitationSection } from '../components/AgitationSection';
import { DreamSection } from '../components/DreamSection';
import { WhyFailedSection } from '../components/WhyFailedSection';
import { MechanismSection } from '../components/MechanismSection';
import { LibrarySection } from '../components/LibrarySection';
import { ForWhoSection } from '../components/ForWhoSection';
import { ProofSection } from '../components/ProofSection';
import { UrgencySection } from '../components/UrgencySection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { CTASection } from '../components/CTASection';
import { FAQSection } from '../components/FAQSection';
export function SalesLetter() {
  return <main className="w-full" style={{
    background: 'var(--color-bg)',
    color: 'var(--color-text)'
  }} data-id="element-362">
      <HeroSection data-id="element-363" />
      <PainSection data-id="element-364" />
      <AgitationSection data-id="element-365" />
      <DreamSection data-id="element-366" />
      <WhyFailedSection data-id="element-367" />
      <MechanismSection data-id="element-368" />
      <LibrarySection data-id="element-369" />
      <ForWhoSection data-id="element-370" />
      <ProofSection data-id="element-371" />
      <UrgencySection data-id="element-372" />
      <GuaranteeSection data-id="element-373" />
      <CTASection data-id="element-374" />
      <FAQSection data-id="element-375" />

      {/* Footer */}
      <footer className="py-10 px-4 text-center" style={{
      background: '#0a0a0a',
      borderTop: '1px solid var(--color-border)'
    }} data-id="element-376">
        <p className="text-sm" style={{
        color: 'var(--color-text-muted)'
      }} data-id="element-377">
          © 2025 Crecimiento AudioPro. Todos los derechos reservados.
        </p>
        <p className="text-xs mt-2" style={{
        color: 'var(--color-text-muted)',
        opacity: 0.6
      }} data-id="element-378">
          Garantía respaldada por Hotmart. Resultados individuales pueden
          variar.
        </p>
      </footer>
    </main>;
}